export default {"src":"/_next/static/media/tab-settings.62c26cea.svg","height":40,"width":41};